/**
 * INFO LINE — Riga "etichetta a sinistra, valore a destra" dei blocchi
 * "Info chiave" delle schermate di dettaglio.
 *
 * Non impone nulla sul valore: dentro `children` sta tipicamente un
 * `EditableField`, ma può starci qualsiasi nodo.
 *
 * È esportato dalla public API di @crm/core perché è il componente che rende
 * un campo contribuito da un plugin (SlotContributor su 'detail-left:info')
 * indistinguibile da un campo core: stesso markup, stesse classi, stesso
 * allineamento. Le classi `.info-row*` vivono in `styles/_components.scss`.
 */

import type { ReactNode } from 'react';

export interface InfoLineProps {
  label: string;
  children: ReactNode;
}

export function InfoLine({ label, children }: InfoLineProps) {
  return (
    <div className="info-row">
      <div className="info-row__label">{label}</div>
      <div className="info-row__value">{children}</div>
    </div>
  );
}
